import {UI, StyleSheet, registerStyle, styleRule} from "../../../stem-core/src/ui/UI.js";
import {SUPPORT_EMAIL_ADDRESS} from "../../Constants.js";
import {Messages} from "../../Messages.js";
import {TermsMessage} from "./TermsMessage.jsx";


class FooterStyle extends StyleSheet {
    @styleRule
    container = {
        margin: "auto",
        width: "100%",
        maxWidth: this.themeProps.BASE_CARD_WIDTH,
        textAlign: "center",
        color: this.themeProps.MERCHANT_2,
        padding: 12,
        fontSize: this.themeProps.FONT_SIZE_NORMAL,
    };

    @styleRule
    email = {
        fontWeight: "bold",
        color: "inherit",
        textDecoration: "none",
    };

    @styleRule
    terms = {
        color: () => this.themeProps.MERCHANT_2 + "!important",
        display: "block",
        margin: "auto",
        fontSize: "inherit !important",
        marginBottom: 8,
        ">*": {
            marginTop: 0,
        }
    }
}

@registerStyle(FooterStyle)
export class Footer extends UI.Element {
    render() {
        const {styleSheet} = this;

        return [
            <TermsMessage className={styleSheet.terms} preMessage={Messages.termsPreMessage} postMessage={Messages.termsAuthenticated}/>,
            <div>
                <span>{Messages.footerSupportEmailText}</span>{" "}
                <a target="_blank" href={"mailto:" + SUPPORT_EMAIL_ADDRESS} className={styleSheet.email}>
                    {SUPPORT_EMAIL_ADDRESS}
                </a>
                .
            </div>,
        ];
    }
}
